/**
 * @generated SignedSource<<bea365e8904e109fb98c0efa505290bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageType = "MEMBERSHIP" | "STANDARD";
export type ModalLoaderQuery$variables = {
  packageType: PackageType;
};
export type ModalLoaderQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly allPackages?: {
          readonly count: number;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"PackagesList_customer">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ModalLoaderQuery = {
  response: ModalLoaderQuery$data;
  variables: ModalLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "packageType"
  }
],
v1 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "packageType"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v3 = {
  "alias": "allPackages",
  "args": [
    (v1/*: any*/)
  ],
  "concreteType": "MemberPackageConnection",
  "kind": "LinkedField",
  "name": "memberPackages",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberPackageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberPackage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingOption",
                "kind": "LinkedField",
                "name": "billingOptions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingCharge",
                    "kind": "LinkedField",
                    "name": "billingCharges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frequency",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareItemVariation",
                        "kind": "LinkedField",
                        "name": "squareVariation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isPackage"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DisplayInApp",
                "kind": "LinkedField",
                "name": "displayInApp",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderConnection",
            "kind": "LinkedField",
            "name": "orders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "packageDueDate",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "squareCard",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expYear",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startsOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endsOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModalLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PackagesList_customer"
                      },
                      (v3/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModalLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "packageType",
                                "variableName": "packageType"
                              },
                              {
                                "kind": "Literal",
                                "name": "saleAvailability",
                                "value": "PUBLIC"
                              }
                            ],
                            "concreteType": "PackageConnection",
                            "kind": "LinkedField",
                            "name": "packages",
                            "plural": false,
                            "selections": (v2/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "activePackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "ACTIVE"
                          },
                          (v1/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "upcomingPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "UPCOMING"
                          },
                          (v1/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "expiredPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "EXPIRED"
                          },
                          (v1/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e8282c39f4ff9c0c8e3c66e4dd44fdc",
    "id": null,
    "metadata": {},
    "name": "ModalLoaderQuery",
    "operationKind": "query",
    "text": "query ModalLoaderQuery(\n  $packageType: PackageType!\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Customer {\n          ...PackagesList_customer\n          allPackages: memberPackages(type: $packageType) {\n            count\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment PackageItem_memberPackage on MemberPackage {\n  id\n  ...usePackageMonthlyPrice_memberPackage\n  ...usePackageNeedsAttention_memberPackage\n  package {\n    __typename\n    ...usePackageDisplayName_package\n    billingType\n    billingOptions {\n      billingCharges {\n        frequency\n        squareVariation {\n          amount\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  cancelledOn\n  startsOn\n  endsOn\n}\n\nfragment PackagesListEmptyState_customer on Customer {\n  club {\n    ...useClubIsSellingPackages_club\n    id\n  }\n}\n\nfragment PackagesList_customer on Customer {\n  ...PackagesListEmptyState_customer\n  activePackages: memberPackages(type: $packageType, status: ACTIVE) {\n    edges {\n      node {\n        id\n        ...PackageItem_memberPackage\n      }\n    }\n  }\n  upcomingPackages: memberPackages(type: $packageType, status: UPCOMING) {\n    edges {\n      node {\n        id\n        ...PackageItem_memberPackage\n      }\n    }\n  }\n  expiredPackages: memberPackages(type: $packageType, status: EXPIRED) {\n    edges {\n      node {\n        id\n        ...PackageItem_memberPackage\n      }\n    }\n  }\n}\n\nfragment packageMissingPaymentMethod_memberPackage on MemberPackage {\n  squareCard {\n    id\n  }\n  package {\n    __typename\n    billingType\n    id\n  }\n}\n\nfragment packageOrderNeedsPayment_order on Order {\n  status\n  packageDueDate\n}\n\nfragment packagePaymentMethodExpired_memberPackage on MemberPackage {\n  package {\n    __typename\n    billingType\n    id\n  }\n  orders {\n    edges {\n      node {\n        packageDueDate\n        id\n      }\n    }\n  }\n  squareCard {\n    id\n    expMonth\n    expYear\n  }\n}\n\nfragment useClubIsSellingPackages_club on Club {\n  packages(packageType: $packageType, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n\nfragment usePackageMonthlyPrice_memberPackage on MemberPackage {\n  package {\n    __typename\n    billingType\n    billingOptions {\n      billingCharges {\n        frequency\n        squareVariation {\n          amount\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment usePackageNeedsAttention_memberPackage on MemberPackage {\n  id\n  orders {\n    edges {\n      node {\n        ...packageOrderNeedsPayment_order\n        id\n      }\n    }\n  }\n  ...packageMissingPaymentMethod_memberPackage\n  ...packagePaymentMethodExpired_memberPackage\n}\n"
  }
};
})();

(node as any).hash = "d5100d78160cdb017ff3b6a1ea706131";

export default node;
